// URL opener that uses @capacitor/browser on native to open URLs in an in-app browser,
// and falls back to standard window navigation on web.

import { isNative } from './platform';

/**
 * Open a URL appropriately for the current platform.
 * @param url - The URL to open
 * @param external - If true on web, opens in a new tab instead of navigating current window
 */
export async function openUrl(url: string, external = false): Promise<void> {
  if (isNative()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url, presentationStyle: 'popover' });
  } else {
    if (external) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = url;
    }
  }
}
